module.exports = __webpack_public_path__ + "img/icon-white-29.ba4038ca.svg";